// Client layer (TS-2.5.03). The publish workflow's own reportDate + confirm step, kept separate
// from DeckGeneratePanel because "what report date the PM wants on this deck" and "confirming the
// irreversible-feeling act of publishing" are their own volatility (decisions.md D-006/D-107: the
// PM-set reportDate is distinct from dataAsOfUtc, so this control never defaults silently to the
// preview's data-as-of stamp without the PM being able to see and change it).
import { useState } from "react";
import { ConfirmDialog } from "../../components/ConfirmDialog";
import { FormField } from "../../components/FormField";
import { formFieldControlProps } from "../../components/formFieldControlProps";
import { strings } from "../../strings";

export interface DeckPublishDialogProps {
  readonly initialReportDate: string;
  readonly submitting: boolean;
  readonly onPublish: (reportDate: string, markFinal: boolean) => void;
}

const S = strings.decks.publish;

export function DeckPublishDialog({ initialReportDate, submitting, onPublish }: DeckPublishDialogProps) {
  const [reportDate, setReportDate] = useState(initialReportDate);
  const [markFinal, setMarkFinal] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <section className="eg-deck-publish" aria-labelledby="eg-deck-publish-heading">
      <h2 id="eg-deck-publish-heading">{S.heading}</h2>

      <FormField id="eg-deck-report-date" label={S.reportDate} description={S.reportDateHint} required>
        <input
          type="date"
          required
          value={reportDate}
          onChange={(event) => setReportDate(event.target.value)}
          {...formFieldControlProps("eg-deck-report-date", S.reportDateHint)}
        />
      </FormField>

      <label className="eg-deck-publish__mark-final">
        <input type="checkbox" checked={markFinal} onChange={(event) => setMarkFinal(event.target.checked)} />
        {S.markFinal}
      </label>

      <button type="button" disabled={submitting || reportDate.length === 0} onClick={() => setConfirmOpen(true)}>
        {submitting ? S.publishing : S.submit}
      </button>

      <ConfirmDialog
        open={confirmOpen}
        title={S.confirmTitle}
        body={S.confirmBody}
        confirmLabel={S.confirmConfirm}
        cancelLabel={S.confirmCancel}
        onConfirm={() => {
          setConfirmOpen(false);
          onPublish(reportDate, markFinal);
        }}
        onCancel={() => setConfirmOpen(false)}
      />
    </section>
  );
}
